import { createContext, useContext } from "react";

/** Konsolen-Kontext: Konto (Büro-PC) oder Kiosk mit Personal-PIN; Sperren = Patientenmodus */
export const ConsoleContext = createContext<{ mode: "staff" | "account"; lock: (() => void) | null }>({
  mode: "account",
  lock: null,
});
export const useConsole = () => useContext(ConsoleContext);
